import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import {  ExtraSmallButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_EXTRA_SMALL_BUTTONS, RAISED_EXTRA_SMALL_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedExtraSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={ExtraSmallButton} span={RAISED_EXTRA_SMALL_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="xs" color="primary" className="btn-pill btn-air-primary" id="Tooltip-22">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-22" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary btn-air-primary btn-xs</ToolTip>
          {RAISED_EXTRA_SMALL_BUTTONS_LIST.map((data, index) => (
            <CommonRaisedButton key={index} item={data} size="xs" />
          ))}
        </CardBody>
      </Card>
    );
};

export default RaisedExtraSmallButtons;
